import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html'
})
export class RadioComponent implements OnInit {
  radioNgModel = '';
  radioNgModel1 = '';
  radioNgModelError = 'TestValue';

  form!: FormGroup;
  submitted = false;
  isBrowser = true;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      radio: ['', Validators.required]
    });

    this.route.queryParams.subscribe(param => {
      if (param['radioNgModel']) {
        this.radioNgModel = param['radioNgModel'];
      }
      else if (param['radioNgModel1']) {
        this.radioNgModel1 = param['radioNgModel1'];
      }
    });
  }
}